<template>
  <div :class="['container', _isMobile() ? 'mobile' : '']">
    <Header />
    <div :class="['student-container', _isMobile()?'no-padding':'']">
      <a-layout>
        <a-layout-sider v-if="!_isMobile()">
          <SideMenuStudent class="side-menu"/>
        </a-layout-sider>
        <a-layout-content>
          <SideMenuStudent class="side-menu" v-if="_isMobile()" />
          <a-divider v-if="_isMobile()"></a-divider>
          <a-card :bordered="false">
            <router-view />
          </a-card>
        </a-layout-content>
      </a-layout>
    </div>
    <Footer />
  </div>
</template>

<script>
import Vue from "vue";
import { TENANT_CONFIG, ACCESS_TOKEN } from "@/store/mutation-types";
import { mixinDevice } from "@/utils/mixin.js";
import SideMenuStudent from "../components/SideMenuStudent.vue";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { jumpMixins } from "@/utils/jumpMixins"

export default {
  name: "HomeLayout",
  mixins: [mixinDevice,jumpMixins],
  components: {
    Header,
    SideMenuStudent,
    Footer,
  },
  data() {
    return {
      bgUrl: "/assets/background.svg",
    };
  },
  created() {
    const tenantConfig = Vue.ls.get(TENANT_CONFIG);
    if (tenantConfig.homeBackground) {
      this.bgUrl = tenantConfig.themeConfig.homeBackground;
    }
    if(!Vue.ls.get(ACCESS_TOKEN)){
      this.toLogin()
    }
  },
};
</script>

<style lang="less" scoped>
.container {
  // min-height: 100vh;
  background: #f2f6f8;
  background: url(../assets/bg2.jpg);
  .student-container {
    max-width: 1200px;
    margin: 10px auto;
    padding: 20px 30px;
    background: #ffffff4a;
    border-radius: 30px;
  }
  .no-padding{
    padding: 0 !important;
  }
  .ant-layout {
    background: transparent;
  }
  .ant-layout-sider {
    background: transparent;
  }
  .side-menu {
    background: #fff;
    text-align: center;
    border-radius: 10px;
  }
  .ant-card {
    margin: 0 20px;
    background: #fff;
  }
}
</style>